import React from 'react';
import Header from '../components/Header';
import News from '../components/News';
import Clients from '../components/Clients';
import Footer from '../components/Footer';

const NewsPage = () => {
  return (
    <>
      <Header />
      <main id="main">
         <News />
         <Clients />
      </main> 
      <Footer />   
    </>
  );
};

export default NewsPage;